module.exports = __webpack_public_path__ + "static/media/ota-thumbnail.cdfb8235.png";